export default "__VITE_ASSET__7v5$7gqQ__"